import { EffectiveCart } from 'interfaces/cart';
import { isSubscriptionItem } from 'interfaces/line-item';
import sum from 'lodash/sum';

/**
 * Returns the average first-order subscription discount across subscription items.
 *
 * The helper prefers the explicit `subscriptionDiscount` field and falls back to
 * deriving the percentage from `defaultPrice` and `subscriptionPrice`.
 */
export const getSubscriptionDiscountPercentage = (
  effectiveCart: EffectiveCart
): number | undefined => {
  const subscriptionItems = effectiveCart.items.filter(isSubscriptionItem);

  if (subscriptionItems.length === 0) {
    return undefined;
  }

  const discountPercentages = subscriptionItems.map((item) => {
    if (typeof item.subscriptionDiscount === 'number') {
      return item.subscriptionDiscount;
    }

    if (item.defaultPrice > 0 && item.subscriptionPrice) {
      return Math.round((1 - item.subscriptionPrice / item.defaultPrice) * 100);
    }

    return 0;
  });

  const totalDiscountPercentage = sum(discountPercentages);

  return totalDiscountPercentage > 0
    ? totalDiscountPercentage / subscriptionItems.length
    : undefined;
};
